<template>
  <transition>
    <router-view />
  </transition>
</template>

<script>
  export default {
    name: 'App',
  }
</script>

<style >

</style>
